module.exports = __webpack_public_path__ + "img/6.f867f0ed.png";